import Portal from './portal';

export default Portal;
